import { Input, Directive } from '@angular/core';

@Directive()
export class IconMapper {
    @Input() icon: string;

    constructor() {}

    getIconUrl() {
        switch (this.icon) {
            case 'Menu':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Menu.svg';
            case '3-Dot-Menu':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Three_Dot_Vert.svg';
            case 'Bag':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Bag.svg';
            case 'Inbox':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Inbox.svg';
            case 'Mail':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Mail.svg';
            case 'CFA':
                return 'https://d4gii57lvoht3.cloudfront.net/images/CFA_Circle_Logo.png';
            case 'Settings':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Settings.svg';
            case 'Notifications':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Notifications.svg';
            case 'KPS':
                return 'https://d4gii57lvoht3.cloudfront.net/images/KPS.svg';
            case 'POS':
                return 'https://d4gii57lvoht3.cloudfront.net/images/POS.svg';
            case 'Files':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Files.svg';
            case 'Calendar':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Calendar.svg';
            case 'Search':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Search.svg';
            case 'Edit':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Edit.svg';
            case 'Check':
                return 'https://d4gii57lvoht3.cloudfront.net/images/Check.svg';
            default:
                return this.icon;
        }
    }
}
